// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__2YAc0","content--full":"Content_content--full__9kp6L"};